import React, { useEffect } from "react";
import CPV from "./Components/CPV";
import styles from "../../../../BorrowerDetails.module.css";
import { useState } from "react";
// import PennyDrop from "./Components/PennyDrop";
import VCIP from "./Components/VCIP";
import TVR from "./Components/TVR/TVR";
// import TVROLD from "./Components/TVR/TVR(OLD)";
import PD from "./Components/PD/PD";
import CAM from "./Components/CAM/CAM";
import PennyDrop from "./Components/PennyDrop/PennyDrop";
import Verification from "./Components/VerificationNew/VerificationNew"
import DeDuped from "./Components/DeDuped/Deduped";
import AccountAggregator from "../../../Modals/BankDetailsModal/AccountAggregator/AccountAggregator";
import Cookies from 'js-cookie';
import axios from "axios";
import { url } from "../../../../../../../App";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Analysis = ({ cpvUpload, openLoader, closeLoader, permissions }) => {
  const [showDiv, setshowDiv] = useState("");
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [permission, setpermission] = useState(null)
  const navigate = useNavigate();
  useEffect(() => {

    axios
      .post(url + "/user/getsingle", {
        token: token,
        email: email,
        useremail: email
      })
      .then((res) => {
        console.log("user res->", res);
        // setuser(res?.data[0])
        if (res.data.logout === true) {
          toast.error(res.data.message, {
            style: {
              background: "#fab6bb",
              color: "red",
              fontSize: "16px",
              borderRadius: "1rem",
              borderColor: "white"
            },
          });
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
        else {
          console.log("permissions-> ", res?.data[0]?.permission)
          setpermission(res?.data[0]?.permission)
        }
      })
      .catch((err) => {
        toast.error(err, {
          style: {
            background: "#fab6bb",
            color: "red",
            fontSize: "16px",
            borderRadius: "1rem",
            borderColor: "white"
          },
        });
      })
    console.log("permission-> ", permission)
    //eslint-disable-next-line
  }, [token, email]);
  const handleDiv = (e, val) => {
    setshowDiv(val);
  };
  console.log(permissions)

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>

        {permissions.cpv_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "CPV")}
            style={{
              backgroundColor: showDiv === "CPV" ? "#034ea1" : "#eef7ff",
              color: showDiv === "CPV" ? "white" : "gray",
            }}
          >
            CPV
          </button>
        )}
        {/* <button
          className={styles.addhoverButton}
          onClick={(e) => handleDiv(e, "PennyDrop")}
          style={{
            backgroundColor: showDiv === "PennyDrop" ? "#034ea1" : "#eef7ff",
            color: showDiv === "PennyDrop" ? "white" : "gray",
          }}
        >
          Penny Drop
        </button> */}

        {permissions.pd_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "VCIP")}
            style={{
              backgroundColor: showDiv === "VCIP" ? "#034ea1" : "#eef7ff",
              color: showDiv === "VCIP" ? "white" : "gray",
            }}
          >
            Tele PD
          </button>
        )}

        {permissions.tvr_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "TVR")}
            style={{
              backgroundColor: showDiv === "TVR" ? "#034ea1" : "#eef7ff",
              color: showDiv === "TVR" ? "white" : "gray",
            }}
          >
            TVR
          </button>
        )}

        {permissions.video_pd_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "RANDOM")}
            style={{
              backgroundColor: showDiv === "RANDOM" ? "#034ea1" : "#eef7ff",
              color: showDiv === "RANDOM" ? "white" : "gray",
            }}
          >
            Video PD
          </button>
        )}

        {permissions.cam_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "RANDOM1")}
            style={{
              backgroundColor: showDiv === "RANDOM1" ? "#034ea1" : "#eef7ff",
              color: showDiv === "RANDOM1" ? "white" : "gray",
            }}
          >
            CAM
          </button>
        )}

        {permissions.verification_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "Verification")}
            style={{
              backgroundColor: showDiv === "Verification" ? "#034ea1" : "#eef7ff",
              color: showDiv === "Verification" ? "white" : "gray",
            }}
          >
            Verification
          </button>
        )}

        {permissions.cpv_analysis && (
          <button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "DeDuped")}
            style={{
              backgroundColor: showDiv === "DeDuped" ? "#034ea1" : "#eef7ff",
              color: showDiv === "DeDuped" ? "white" : "gray",
            }}
          >
            DeDuped
          </button>
        )}

        {
          (permission?.aa_tab || email === "rupesh.bishnoi@credin.in") && (<button
            className={styles.addhoverButton}
            onClick={(e) => handleDiv(e, "account_aggregator")}
            style={{
              backgroundColor: showDiv === "account_aggregator" ? "#034ea1" : "#eef7ff",
              color: showDiv === "account_aggregator" ? "white" : "gray",
            }}
          >
            Account Aggregator
          </button>)
        }

      </div>

      {showDiv === "CPV" && (
        <div>
          <CPV
            cpvUpload={cpvUpload}
            openLoader={openLoader}
            closeloader={closeLoader}
            permissions={permissions}
          />
        </div>
      )}

      {showDiv === "PennyDrop" && (
        <div>
          <PennyDrop openLoader={openLoader} closeLoader={closeLoader} permissions={permissions} />
        </div>
      )}
      {showDiv === "VCIP" && (
        <div>
          <VCIP permissions={permissions} />
        </div>
      )}

      {showDiv === "TVR" && (
        <div>
          <TVR permissions={permissions} />
        </div>
      )}
      {showDiv === "RANDOM" && (
        <div>
          <PD permissions={permissions} />
        </div>
      )}
      {showDiv === "RANDOM1" && (
        <div>
          <CAM permissions={permissions} />
        </div>
      )}
      {showDiv === "Verification" && (
        <div>
          <Verification permissions={permissions} />
        </div>
      )}
      {showDiv === "DeDuped" && (
        <div>
          <DeDuped permissions={permissions} />
        </div>
      )}
      {showDiv === "account_aggregator" && (
        <div>
          <AccountAggregator permissions={permissions} />
        </div>
      )}
    </>
  );
};

export default Analysis;
